<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localIsOpen"
    :title="title"
    width="xl"
    @close="localIsOpen = false"
  >
    <template #body>
      <div class="flex w-full flex-col overflow-y-auto">
        <AvailabilityItemManagement
          v-if="loaded"
          :id="modelId"
          :target="target"
          :edit-mode="true"
        />
      </div>
    </template>
  </BaseSlideOverModal>
</template>

<script>
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import AvailabilityItemManagement from '@/views/settings/unavailability-item/forms/unavailabilityItem/AvailabilityItemManagement.vue'

export default {
  name: 'UnavailabilityModal',
  components: { BaseSlideOverModal, AvailabilityItemManagement },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    modelId: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: true,
      validator: (value) => ['user', 'resource'].includes(value)
    },
    title: {
      type: String,
      required: true
    }
  },
  emits: ['update:isOpen'],
  data() {
    return {
      loaded: false
    }
  },
  computed: {
    localIsOpen: {
      get() {
        return this.isOpen
      },
      set(value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  watch: {
    isOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loaded = true
      }
    }
  }
}
</script>
